import React from 'react';
import CircularProgress from '@mui/material/CircularProgress';
import PropTypes from "prop-types";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";

export class Loading extends React.Component {
    render() {

        const { height, size, color, sx, label } = this.props;
        let containerHeight = typeof height === 'undefined' ? '100vh' : `${height}px`;
        const bgColor = color || '#003300';

        return(
            <Box sx={{
                ...styles.progressContainer,
                height: containerHeight,
                ...sx
            }}>
                <CircularProgress sx={{color: bgColor}} size={size}/>
                {label && (
                    <Box sx={{ ml: 3, mt: -2 }}>
                        <Typography variant="body2" sx={{ color: bgColor, mt: 2, fontSize: '16px' }}>
                            {label}
                        </Typography>
                    </Box>
                )}
            </Box>
        )
    }
}

const styles = {
    progressContainer: {
        display:'flex',
        alignItems:'center',
        justifyContent:'center',
    }
};

Loading.propTypes = {
    height: PropTypes.number,
    size: PropTypes.number,
    color: PropTypes.string,
    sx: PropTypes.object,
    label: PropTypes.string,
};